import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Bar from './bar';
import * as S from './styles';

export default class Bars extends Component {
  renderBar(data, index) {
    const fillData = this.props.getSectionFillData(index);
    return (
      <Bar
        key={`bar${index}`}
        id={index}
        max={this.props.values.max_matching_products}
        onChange={this.props.onChange}
        fillData={fillData}
        {...data}
      />
    );
  }

  render() {
    return (
      <S.Bars layout={this.props.layout}>
        {this.props.values.values.map(this.renderBar, this)}
      </S.Bars>
    );
  }
}

Bars.propTypes = {
  layout: PropTypes.oneOf(['vertical', 'horizontal']).isRequired,
  values: PropTypes.shape({
    max_matching_products: PropTypes.number,
    max_value: PropTypes.number,
    min_value: PropTypes.number,
    values: PropTypes.arrayOf(
      PropTypes.shape({
        from: PropTypes.number,
        to: PropTypes.number,
        max: PropTypes.number,
        products: PropTypes.number,
      })
    ),
  }).isRequired,
  getSectionFillData: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};
